import { usePermissions } from '@/composables/usePermissions'
import menuConfig from '@/navigation/vertical/production.js'
import { STAFF_ROLES } from '@/helpers/ConstantHelper.js'

export default defineNuxtRouteMiddleware((to) => {
  // Skip middleware for certain routes
  const skipRoutes = ['/not-found', '/login', '/']
  if (skipRoutes.includes(to.path)) {
    return
  }

  const { can } = usePermissions()
  const { data: session } = useAuth()

  if (to.meta.adminOnly && session.value?.user?.role_id !== STAFF_ROLES.SUPERADMIN) {
    return navigateTo('/not-found')
  }


  // Function to find menu item by route name
  const findMenuPermission = (items, routeName) => {
    for (const item of items) {
      // Check if current item matches route
      if (item.to === routeName && item.permission) {
        return item.permission
      }
      
      // Check children if exists
      if (item.children) {
        const childPermission = findMenuPermission(item.children, routeName)
        if (childPermission) {
          return childPermission
        }
      }
    }
    return null
  }

  // Get route name (remove leading slash)
  const routeName = to.name || to.path.replace('/', '')
  
  // Find permission for this route
  const requiredPermission = findMenuPermission(menuConfig, routeName)
  
  // If permission found and user doesn't have it, redirect to not-found
  if (requiredPermission && !can(requiredPermission)) {
    return navigateTo('/not-found')
  }
},  { override: true })
